import { render, staticRenderFns } from "./Grouplist.vue?vue&type=template&id=ab884e5e&scoped=true&"
import script from "./Grouplist.vue?vue&type=script&lang=js&"
export * from "./Grouplist.vue?vue&type=script&lang=js&"
import style0 from "./Grouplist.vue?vue&type=style&index=0&id=ab884e5e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab884e5e",
  null
  
)

export default component.exports